import { render, staticRenderFns } from "./Paneles.vue?vue&type=template&id=532f983e&scoped=true"
import script from "./Paneles.vue?vue&type=script&lang=js"
export * from "./Paneles.vue?vue&type=script&lang=js"
import style0 from "./css/Paneles.vue.css?vue&type=style&index=0&id=532f983e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532f983e",
  null
  
)

export default component.exports